<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="actividades"
	[displayWith]="displayActividad"
	[value]="selectedActividad"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
